import ApiHandler from './ApiHandler'

export default {
  postLead: data => ApiHandler.post('leads', data),
  getLeads: () => ApiHandler.get('leads'),
  subscribeToNewsletter: data => ApiHandler.post('email-subscription', data),
  unsubscribeFromNewsletter: email => ApiHandler.get(`newsletter/unsubscribe?email=${email}`)
}
